/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChangeLogElement } from '../models/ChangeLogElement';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AppService {
    /**
     * Get App Version
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getAppVersionAppVersionGet(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/version',
        });
    }
    /**
     * Get Privacy
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getPrivacyAppPrivacyGet(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/privacy',
        });
    }
    /**
     * Get Tos
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getTosAppTosGet(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/tos',
        });
    }
    /**
     * Get Privacy
     * @param lang
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getPrivacyAppPrivacyLangGet(
        lang: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/privacy/{lang}',
            path: {
                'lang': lang,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Tos
     * @param lang
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getTosAppTosLangGet(
        lang: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/tos/{lang}',
            path: {
                'lang': lang,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static updateAppUpdateGet(): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/update',
        });
    }
    /**
     * Get Update Required
     * @param version
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static getUpdateRequiredAppUpdateRequiredVersionGet(
        version: string,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/update_required/{version}',
            path: {
                'version': version,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Agb Level
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getAgbLevelAppAgbLevelGet(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/agb_level',
        });
    }
    /**
     * Get Changelog
     * @param offset
     * @param limit
     * @returns ChangeLogElement Successful Response
     * @throws ApiError
     */
    public static getChangelogAppChangelogGet(
        offset?: number,
        limit: number = 50,
    ): CancelablePromise<Array<ChangeLogElement>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app/changelog',
            query: {
                'offset': offset,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
